import React, { useEffect } from 'react';
import Dragger from 'draggerjs'
import { SectionWithCode } from 'Templates';
import * as code from '../StringCodes'; 

export const RawDrag = () => {
    
    useEffect(() => {
        let cleanUp
        let isComplete = false 
        const target = document.querySelector('.drag-drawer-content')
        
        const dragger = new Dragger('#drag-raw-drag')
        dragger.on('dragstart', (e) => { 
            if(target === e.target) {
                e.target.nodeName !== 'A' && e.preventDefault()
                target.style.left = (isComplete ? 0 : -target.clientWidth) + 'px'
                target.classList.remove('draw-transition')  
                clearTimeout(cleanUp)
            }
        })
        dragger.on('dragmove', (e) => {    
            if(target === e.target) {
                const width = target.clientWidth  
                const distance = (isComplete ? e.moveX - e.startX : (e.moveX - e.startX) - width)
                target.style.left = (0 > distance ? -width > distance ? -width : distance : 0) + 'px' 
            }
        }) 
        dragger.on('dragend', (e) => { 
            if(target === e.target) {
                const width = target.clientWidth 
                const distance = isComplete ? (e.endX - e.startX) + width :  e.endX - e.startX 
                if(distance > target.clientWidth/2) {
                    target.classList.add('draw-full')
                    isComplete = true
                } else {  
                    target.classList.remove('draw-full') 
                    isComplete = false
                }
                target.style.left = null
                target.classList.add('draw-transition') 
                cleanUp = setTimeout(() => {
                    target.classList.remove('draw-transition')
                }, 300) 
            }
        })
        return () => {
            clearTimeout(cleanUp)
            dragger.destroy()
        }
    }, [])

    return (
        <>  
            <SectionWithCode
                readonly
                title='Raw Draggable'
                context='you can create with your own drag mechanics.'
                code={code.RawDrag}
            >
                <div className="drag-drawer n-bordered" id="drag-raw-drag" data-example>  
                    <div className="drag-drawer-content n-no-shadow n-engrave" > 
                        <nav className="n-nav n-nav-flat n-nav-column" onClick={(e) => e.preventDefault()}>
                            <a className="n-nav-link" href="#">link-1</a>
                            <a className="n-nav-link" href="#">link-2</a>
                            <a className="n-nav-link" href="#">link-3</a>
                        </nav> 
                    </div>
                </div>
            </SectionWithCode>
        </>
    );
}